let mojitoUtils = {
    _observeCallback: function () {
        var listener,
            elements,
            finishedListeners = [],
            listenerIdx,
            i, c;
        for (i=0, c=this.listeners.length; i<c; i++) {
            listener = this.listeners[i];
            if (!listener || listener.executed) {
                continue;
            }

            elements = document.querySelectorAll(listener.selector);

            if (!elements.length) {
                continue;
            }

            // Once: Only invoke the callback on the first match
            if (listener.options.once && !listener.executed) {
                listener.executed = true;
                finishedListeners.push(listener);
                listener.fn(elements[0]);
            } else {
                for (var j=0, jc=elements.length; j<jc; j++) {
                    // Skip observed elements
                    if (elements[j]['_observed' + listener.index]) {
                        continue;
                    }

                    elements[j]['_observed' + listener.index] = true;
                    listener.fn(elements[j]);
                }
            }

            if (listener.timeoutHandle) {
                window.clearTimeout(listener.timeoutHandle);
            }
        }

        // Remove "once" listeners
        for (i=0, c=finishedListeners.length; i<c; i++) {
            listenerIdx = this.listeners.indexOf(finishedListeners[i]);
            if (listenerIdx != -1) {
                this.listeners.splice(listenerIdx, 1);
            }
        }
    },
    _observeTimeout: function (listener) {
        var idx = this.listeners.indexOf(listener);

        if (idx == -1) {
            return;
        }

        this.listeners.splice(idx, 1);

        // Call onTimeout callback
        if (listener.options.onTimeout && this.isFunction(listener.options.onTimeout)) {
            listener.options.onTimeout();
        }
    },
    observeSelector: function (selector, callback, options) {
        if (!options) {
            options = {};
        }

        var self = this;
        // Use single observer for multi calls
        if (!this.domObserver) {
            this.listenerCount = 0;
            this.listeners = [];
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            this.domObserver = new MutationObserver(this._observeCallback.bind(this));
            this.domObserver.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        }

        var listener = {
            selector: selector, fn: callback, options: options, index: (++this.listenerCount) + 'w'
        };
        this.listeners.push(listener);

        var timeout = parseInt(options.timeout, 10);
        if (!isNaN(timeout)) {
            listener.timeoutHandle = window.setTimeout(function () {
                self._observeTimeout(listener);
            }, timeout);
        }

        // Trigger the first check
        this._observeCallback();
    },
    waitForElement: function (selector, callback, timeout) {
        this.observeSelector(selector, callback, { timeout: timeout, once: true });
    },
    watchElement: function (selectorOrElement, callback, watchOptions) {
        var isSelector = typeof(selectorOrElement) == 'string';
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        var domWatcher = new MutationObserver(callback);

        if (!watchOptions) {
            watchOptions = {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true
            };
        }

        var elements;
        if (isSelector) {
            elements = document.querySelectorAll(selectorOrElement);
        } else {
            elements = [selectorOrElement];
        }

        for (var i=0; i<elements.length; i++) {
            domWatcher.observe(elements[i], watchOptions);
        }
    },
    _waitUntilChecker: function () {
        var listener,
            finishedListeners = [],
            i, c;

        for (i=0, c=this.waitListeners.length; i<c; i++) {
            listener = this.waitListeners[i];
            if (listener.condition()) {
                finishedListeners.push(listener);
                listener.callback();
            } else {
                // Timeout reached?
                if (listener.timeout && (((new Date()).getTime() - listener.start) >= listener.timeout)) {
                    finishedListeners.push(listener);
                }
            }
        }

        // Remove finished listeners
        for (i=0, c=finishedListeners.length; i<c; i++) {
            this.waitListeners.splice(this.waitListeners.indexOf(finishedListeners[i]), 1);
        }

        if (this.waitListeners.length) {
            this.waitHandle = window.setTimeout(this._waitUntilChecker.bind(this), 50);
        } else {
            window.clearTimeout(this.waitHandle);
        }
    },
    waitUntil: function (conditionFunction, callback, timeout) {
        if (timeout != null) {
            timeout = parseInt(timeout, 10);

            if (isNaN(timeout) || timeout <= 0) {
                throw new Error('waitUntil: timeout parameter must be an positive Integer.');
            }
        } else {
            timeout = 2000;
        }

        if (!this.waitListeners) {
            this.waitListeners = [];
        }

        // First check
        if (conditionFunction()) {
            callback();
            return;
        }

        var listener = { condition: conditionFunction, callback: callback, timeout: timeout };
        this.waitListeners.push(listener);

        if (timeout) {
            listener.start = (new Date()).getTime();
        }

        this.waitHandle = window.setTimeout(this._waitUntilChecker.bind(this), 50);
    }
};